import { history } from '../entry/history';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import typesCommonCore from 'pluton-core/lib/actions/types/common.types'


export const failError = (dispatch, error) => {
    throw error;
};

export const fail404 = (dispatch) => {
    return history.replace(routes.notFound());
};

export const failNonAuth = (dispatch) => {
    return history.push(routes.login());
};

export const getCallbackErrors = () => {
    return {
        [typesCommonCore.COMMON_CALLBACK_404]: fail404,
        [typesCommonCore.COMMON_CALLBACK_ERROR]: failError,
        [typesCommonCore.COMMON_CALLBACK_NON_AUTH]: failNonAuth,
    };
};



// WEBPACK FOOTER //
// ./app/actions/common.actions.js